import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/modules/auth/store'

// Lazy-loaded pages
const LandingPage       = () => import('@/pages/LandingPage.vue')
const LoginPage         = () => import('@/pages/LoginPage.vue')
const RegisterPage      = () => import('@/pages/RegisterPage.vue')
const AppPage           = () => import('@/pages/AppPage.vue')
const AppEntryPage      = () => import('@/pages/AppEntryPage.vue')
const EditorPage        = () => import('@/pages/EditorPage.vue')
const NotFoundPage      = () => import('@/pages/NotFoundPage.vue')
// Docs (B10)
const DocsPage          = () => import('@/pages/DocsPage.vue')
const DocsStartPage     = () => import('@/pages/docs/DocsStartPage.vue')
const DocsFilesPage     = () => import('@/pages/docs/DocsFilesPage.vue')
const DocsAntiHaloPage  = () => import('@/pages/docs/DocsAntiHaloPage.vue')
const DocsPricingPage   = () => import('@/pages/docs/DocsPricingPage.vue')
const DocsFaqPage       = () => import('@/pages/docs/DocsFaqPage.vue')
const PrivacyPage       = () => import('@/pages/docs/PrivacyPage.vue')
const TermsPage         = () => import('@/pages/docs/TermsPage.vue')

// B9: AccountPage

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/',                       name: 'landing',  component: LandingPage },
    { path: '/login',                  name: 'login',    component: LoginPage,    meta: { guestOnly: true } },
    { path: '/register',               name: 'register', component: RegisterPage, meta: { guestOnly: true } },
    // /app не показывает экран-прокладку: сразу открывает последнюю раскладку
    // (или создаёт черновик). Список раскладок — в выпадашке шапки редактора.
    { path: '/app',                    name: 'app',      component: AppEntryPage, meta: { requiresAuth: true } },
    { path: '/app/projects',           name: 'projects', component: AppPage,      meta: { requiresAuth: true } },
    { path: '/app/projects/:id',       name: 'editor',   component: EditorPage,   meta: { requiresAuth: true } },
    // Docs (B10)
    {
      path: '/docs',
      component: DocsPage,
      children: [
        { path: '',         redirect: '/docs/start' },
        { path: 'start',    name: 'docs-start',    component: DocsStartPage },
        { path: 'files',    name: 'docs-files',    component: DocsFilesPage },
        { path: 'antihalo', name: 'docs-antihalo', component: DocsAntiHaloPage },
        { path: 'pricing',  name: 'docs-pricing',  component: DocsPricingPage },
        { path: 'faq',      name: 'docs-faq',      component: DocsFaqPage },
        { path: 'privacy',  name: 'privacy',       component: PrivacyPage },
        { path: 'terms',    name: 'terms',         component: TermsPage },
      ],
    },
    { path: '/:pathMatch(.*)*',        name: 'not-found', component: NotFoundPage },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  // Первый заход — восстанавливаем сессию из cookie
  if (auth.user === null && !auth.loading) {
    await auth.initFromSession()
  }

  // Анонимный пользователь считается аутентифицированным для editor-маршрутов,
  // но НЕ блокируется с /login и /register — ему нужно туда зайти для claim-flow.
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } }
  }

  // guestOnly-страницы (login, register) редиректят только реально залогиненного
  // (не анонима) пользователя — аноним должен иметь возможность зарегистрироваться.
  if (to.meta.guestOnly && auth.isAuthenticated && !auth.isAnonymous) {
    return { name: 'app' }
  }
})
